//=============================================================================
//                       <--- Developed By Icon Team ---> 02 february 2021
//=============================================================================

// npm packages
import React, { useState, useEffect, useContext, useCallback } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import DateFnsUtils from "@date-io/date-fns";
import * as moment from "moment";


// custom pages
import { styles } from "./styles";
import role from "apis/role/role";
import Context from "context/context";

// material-ui
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import IconButton from "@material-ui/core/IconButton";

// material-ui icons
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { Fragment } from "react";

//Helpers
import {dateFormat} from "helpers/dataFormat"
import benefitcode from "apis/BenefitCode/benefitcode";

// custom TextField
const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#707070",
    },
    "& .MuiInputBase-input": {
      color: "#707070",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#707070",
      },
      "&:hover fieldset": {
        borderColor: "#707070",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#707070",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: 20,
      },
      "&.MuiOutlinedInput-root": {
        marginTop: 0,
        borderRadius: 20,
      },
    },
  },
})(TextField);

export default function View(props) {
  const { state, dispatch } = useContext(Context);
  const {updateBenefitCode} = benefitcode();
  const history = useHistory();
  const location = useLocation();
  const classes = styles();
  ;
  const [states, setstates] = useState({
    id:"",
    tier:"",
    privilegeType:"",
    privilegeCode:"",
    Default:"",
    defaultAssign:"",
    isActive: true,
    data: {},
    edittedData: {},
    isEdit: false,
    loading: false,
  });

  const {
    id,
    tier,
    privilegeType,
    privilegeCode,
    Default,
    defaultAssign,
    data,
    edittedData,
    isEdit,
    loading,
  } = states;

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  useEffect(() => {
    if (location?.state?.data) {
      let dataObj = location?.state?.data;
      setDataObj(dataObj);
    }
  }, []);

  const setDataObj = (dataObj) => {
    setStates({
      data: dataObj,
      id: dataObj?.id,
      tier: dataObj?.tier,
      privilegeType: dataObj?.privilege_type,
      privilegeCode: dataObj?.privilege_code,
      Default: dataObj?.default,
      defaultAssign:dataObj?.default_assign
    });
  };

  useEffect(() => {
    dispatch({
      type: "SET_PATHNAME",
      payload: ["HOME", "ADMIN", "BENEFITCODE", "VIEW"],
    });
  }, []);
  
  const handleUpdateBenefitCode = async () => {
    // console.log("ca;lledd")
    try {
      if (Object.keys(edittedData).length === 0) {
        toast.error("Please alter atleast one field.", {
          toastId: "update-error",
        });
        setStates({ loading: false });
        return;
      }
      let failed = false;
      Object.keys(edittedData).map((o) => {
        if (!edittedData[o] && typeof edittedData[o] != "boolean") {
          failed = true;
        }
      });
      if (failed) {
        toast.error("Cannot update empty field.", {
          toastId: "update-error-2",
        });
        setStates({ loading: false });
        return;
      }

      let values;
      values = {
        ...edittedData,
        id: data?.id,
      };
      let res = await updateBenefitCode(values);
      if (res?.data === 1) {
        toast.success("Updated", { toastId: "rule-updated" });
        history.goBack();
      }
      setStates({ loading: false });
    } 
    catch (e) {
      console.log({ e });
    }
  };

  return (
    <React.Fragment>
      <Grid container spacing={0} style={{ padding: 10 }}>
        <Grid item xs={12}>
          <IconButton
            onClick={() => {
              history.goBack();
            }}
          >
            <ArrowBackIcon style={{ color: "#305698" }} />
          </IconButton>
          <span style={{ fontSize: 18 }}>
            <strong> {'ID'} :</strong> {data?.id}
          </span>
          {!isEdit && (
            <Button
              className={`${classes.createBtn} dash-1-filter-btn`}
              onClick={() => {
                setStates({ isEdit: true });
              }}
            >
              {'Edit'}
            </Button>
          )}
        </Grid>
      </Grid>
      <Grid container spacing={4} style={{ padding: 10, fontSize: 16 }}>
        <Grid item xs={10}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}>{'Tier'} : </strong>
            </Grid>
            <Grid item xs={8}>
              {
                isEdit ? (
                  <CssTextField
                    variant="outlined"
                    type={"text"}
                    required
                    className={classes.editInput}
                    value={tier}
                    onChange={(e) => {
                      setStates({
                        tier: e.target.value,
                        edittedData: {
                          ...edittedData,
                          tier: e.target.value,
                        },
                      });
                    }}
                  />
                ) : <span className={classes.label}>{tier}</span>
              }
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={10}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}>{'Privilege Type'} : </strong>
            </Grid>
            <Grid item xs={8}>
              {
                isEdit ? (
                  <CssTextField
                    variant="outlined"
                    type={"text"}
                    required
                    className={classes.editInput}
                    value={privilegeType}
                    onChange={(e) => {
                      setStates({
                        privilegeType: e.target.value,
                        edittedData: {
                          ...edittedData,
                          privilegeType: e.target.value,
                        },
                      });
                    }}
                  />
                ) : <span className={classes.label}>{privilegeType}</span>
              }
            </Grid>
          </Grid>
        </Grid>   
        <Grid item xs={10}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}>{'Privilege Code'} : </strong>
            </Grid>
            <Grid item xs={8}>
              {
                isEdit ? (
                  <CssTextField
                    variant="outlined"
                    type={"text"}
                    required
                    className={classes.editInput}
                    value={privilegeCode}
                    onChange={(e) => {
                      setStates({
                        privilegeCode: e.target.value,
                        edittedData: {
                          ...edittedData,
                          privilegeCode: e.target.value,
                        },
                      });
                    }}
                  />
                ) : <span className={classes.label}>{privilegeCode}</span>
              }
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={10}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}> {'Default'} : </strong>
            </Grid>
            <Grid item xs={8}>
              {
                isEdit ? (
                  <CssTextField
                    variant="outlined"
                    id={"Oneweb Authorized"}
                    select
                    type={"text"}
                    required
                    className={classes.editInput}
                    value={Default}
                    onChange={(e) => {
                      setStates({
                        Default: e.target.value,
                        edittedData: {
                          ...edittedData,
                          Default: e.target.value,
                        },
                      });
                    }}
                  >
                    {[
                      { label: "Yes", value: true },
                      { label: "No", value: false },
                    ].map((t, i) => (
                      <MenuItem value={t.value} key={i}>
                        {t.label}
                      </MenuItem>
                    ))}
                  </CssTextField>
                ) : <span className={classes.label}>{Default?'Yes':'No'}</span>
              }
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={10}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}> {'Default Assign'} : </strong>
            </Grid>
            <Grid item xs={8}>
              {
                isEdit ? (
                  <CssTextField
                    variant="outlined"
                    id={"Oneweb Authorized"}
                    select
                    type={"text"}
                    required
                    className={classes.editInput}
                    value={defaultAssign}
                    onChange={(e) => {
                      setStates({
                        defaultAssign: e.target.value,
                        edittedData: {
                          ...edittedData,
                          defaultAssign: e.target.value,
                        },
                      });
                    }}
                  >
                    {[
                      { label: "Yes", value: true },
                      { label: "No", value: false },
                    ].map((t, i) => (
                      <MenuItem value={t.value} key={i}>
                        {t.label}
                      </MenuItem>
                    ))}
                  </CssTextField>
                ) : <span className={classes.label}>{defaultAssign?'Yes':'No'}</span>
              }
            </Grid>
          </Grid>
        </Grid>

        
        
      </Grid>
      <Grid container spacing={0} style={{ padding: 10 }}>
        <Grid item xs={12} style={{ textAlign: "right" }}>
          {
            isEdit && (
              <Fragment>
                <Button
                  className={classes.cancelBtn}
                  onClick={() => {
                    setDataObj(data);
                    setStates({ isEdit: false, edittedData: {} });
                  }}
                >
                  {'Cancel'}
                </Button>
                &nbsp; &nbsp; &nbsp;
                <Button
                  className={classes.submitBtn}
                  onClick={() => {
                    setStates({ loading: true });
                    handleUpdateBenefitCode();
                  }}
                  disabled={loading}
                >
                  {'Update'}
                </Button>
              </Fragment>
            )
          }
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
